import { axios } from '@/utils/request'

const api = {
  master: '/master/TeamMaster',
}

export function memberInfo(parameter) {
  return axios({
    url: '/master/memberInfo/get/' + `${parameter}`,
    method: 'get',
    timeout: 60000,
  })
}

export function masterInfo(parameter) {
  return axios({
    url: '/master/info/get/' + `${parameter}`,
    method: 'get',
    timeout: 60000,
  })
}

export function memberInfoSelectOrderNum(parameter) {//团队接单情况
  return axios({
    url: 'master/memberInfo/selectOrderNum',
    method: 'get',
    params: parameter,
    timeout: 60000,
  })
}
export function infoSelectOrder(parameter) {//团员接单情况
  return axios({
    url: 'master/info/selectOrder',
    method: 'get',
    params: parameter,
    timeout: 60000,
  })
}

//团队服务区域区
export function selectServeArea(parameter) {
  return axios({
    url: '/master/server/selectServeArea',
    method: 'get',
    params: parameter,
    timeout: 60000,
  })
}

//团员服务区域区
export function selectArea(parameter) {
  return axios({
    url: '/master/MemberServer/selectArea',
    method: 'get',
    params: parameter,
    timeout: 60000,
  })
}

export function memberPriceList(parameter) {//查询团员信息
  return axios({
    url: '/master/memberPrice/List',
    method: 'get',
    params: parameter,
    timeout: 60000,
  })
}

export function memberPriceUpdate(parameter) {//修改团员信息
  return axios({
    url: '/master/memberPrice/update',
    method: 'post',
    data: parameter,
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    },
    timeout: 60000,
  })
}


export function memberList(parameter) {
  return axios({
    url: '/master/memberList/list',
    method: 'get',
    params: parameter,
    timeout: 60000,
  })
}

export function SubAccountget(parameter) {
  return axios({
    url: '/master/SubAccount/get/' + `${parameter}`,
    method: 'get',
    timeout: 60000,
  })
}

export function MemberServer(parameter) {//团员服务区域
  return axios({
    url: '/master/MemberServer/list/' + `${parameter}`,
    method: 'get',
    timeout: 60000,
  })
}

export function masterof(parameter) {
  return axios({
    url: '/master/info/get/' + `${parameter}`,
    method: 'get',
    timeout: 60000,
  })
}

export function Pointget(parameter) {//团队电子围栏查看
  return axios({
    url: '/master/Point/get/' + `${parameter}`,
    method: 'get',
    timeout: 60000,
  })
}

export function PointgetMember(parameter) {//团员电子围栏查看
  return axios({
    url: '/master/Point/getMember/' + `${parameter}`,
    method: 'get',
    timeout: 60000,
  })
}
export function PointinsertMember(parameter) {//新增团员电子围栏
  return axios({
    url: '/master/Point/insertMember',
    method: 'post',
    timeout: 60000,
    data: parameter,
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    }
  })
}

export function Pointinsert(parameter) {//新增团队电子围栏
  return axios({
    url: '/master/Point/insert',
    method: 'post',
    timeout: 60000,
    data: parameter,
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    }
  })
}

export function MemberInfoget(parameter) {//团队详情
  return axios({
    url: '/master/memberInfo/get/' + `${parameter}`,
    method: 'get',
    timeout: 60000,
  })

}

export function Serverlist(parameter) {//查询团队服务区域
  return axios({
    url: '/master/server/list/' + `${parameter}`,
    method: 'get',
    timeout: 60000,
  })
}

export function MemberServerdelete(parameter) {//删除团员服务区域
  return axios({
    url: '/master/MemberServer/delete',
    method: 'post',
    data: parameter,
    timeout: 60000,
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    }
  })
}

export function batchDelete2(parameter) {//批量删除团员服务区域
  return axios({
    url: '/master/MemberServer/batchDelete',
    method: 'post',
    data: parameter,
    timeout: 60000,
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    }
  })
}


export function MemberServerInsert(parameter) {//添加团员服务区域
  return axios({
    url: '/master/MemberServer/insert',
    method: 'post',
    data: parameter,
    timeout: 60000,
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    }
  })
}
export function Serverinsert(parameter) {//添加团队服务区域
  return axios({
    url: '/master/server/insert',
    method: 'post',
    timeout: 60000,
    data: parameter,
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    }
  })
}

export function Serverdelete(parameter) {//删除团队服务区域
  return axios({
    url: '/master/server/delete',
    method: 'post',
    timeout: 60000,
    data: parameter,
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    }
  })
}


export function batchDelete(parameter) {//批量删除团队服务区域
  return axios({
    url: '/master/server/batchDelete',
    method: 'post',
    timeout: 60000,
    data: parameter,
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    }
  })
}

export function SubAccount(parameter) {
  return axios({
    url: '/master/SubAccount/list',
    method: 'get',
    timeout: 60000,
    params: parameter
  })
}


export function list(parameter) {
  return axios({
    url: api.master + '/list',
    method: 'get',
    timeout: 60000,
    params: parameter
  })
}



export function teamList(parameter) {
  return axios({
    url: '/master/teamList/list',
    method: 'get',
    timeout: 60000,
    params: parameter
  })
}

export function teamRoleAll(parameter) {
  return axios({
    url: '/system/role/teamRoleAll',
    method: 'get',
    timeout: 60000,
    params: parameter,
  })
}

export function SubAccountrole(parameter) {
  return axios({
    url: '/master/SubAccount/role',
    method: 'get',
    timeout: 60000,
    params: parameter,
  })
}
export function memberDelete(parameter) {//团员列表删除
  return axios({
    url: '/master/memberList/delete',
    method: 'post',
    timeout: 60000,
    data: parameter,
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    }
  })
}

export function memberDisable(parameter) {//团员列表禁用
  return axios({
    url: '/master/memberList/disable',
    method: 'post',
    timeout: 60000,
    data: parameter,
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    }
  })
}

export function memberOpen(parameter) {//团员列表启用
  return axios({
    url: '/master/memberList/open',
    method: 'post',
    timeout: 60000,
    data: parameter,
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    }
  })
}
export function disableContract(parameter) {//团员合同禁用
  return axios({
    url: '/master/info/disableContract',
    method: 'get',
    timeout: 60000,
    params: parameter,
  })
}

export function openContract(parameter) {//团员合同启用
  return axios({
    url: '/master/info/openContract',
    method: 'get',
    timeout: 60000,
    params: parameter,
  })
}

export function infoContract(parameter) {//团员合同列表
  return axios({
    url: '/master/info/listContract/' + `${parameter}`,
    method: 'get',
    timeout: 60000,
  })
}

export function listContract(parameter) {//团队合同列表
  return axios({
    url: '/master/memberInfo/listContract/' + `${parameter}`,
    method: 'get',
    timeout: 60000,
  })
}

export function deleteContract(parameter) {//团员合同删除
  return axios({
    url: '/master/info/deleteContract',
    method: 'get',
    params: parameter,
    timeout: 60000,
  })
}

export function TeamExportTeam(parameter) {//团队管理导出
  return axios({
    url: '/master/TeamMaster/exportTeam',
    method: 'get',
    params: parameter,
    timeout: 60000,
    responseType: 'arraybuffer',
    headers: {
      'Content-Type': 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    }
  })
}
export function infodisable(parameter) {//团队合同禁用
  return axios({
    url: '/master/memberInfo/disable',
    timeout: 60000,
    method: 'post',
    data: parameter,
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    }
  })
}

export function infopen(parameter) {//团队合同启用
  return axios({
    url: '/master/memberInfo/open',
    timeout: 60000,
    method: 'post',
    data: parameter,
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    }
  })
}

export function infoupdateCont(parameter) {//团员合同修改
  return axios({
    url: '/master/info/updateContract',
    timeout: 60000,
    method: 'post',
    data: parameter,
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    }
  })
}

export function updateContract(parameter) {//团队合同修改
  return axios({
    url: '/master/memberInfo/updateContract',
    timeout: 60000,
    method: 'post',
    data: parameter,
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    }
  })
}
export function updateMain2(parameter) {//修改团员主合同
  return axios({
    timeout: 60000,
    url: '/master/info/updateMain',
    method: 'post',
    data: parameter,
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    }
  })
}


export function updateMain(parameter) {//修改团队主合同
  return axios({
    timeout: 60000,
    url: '/master/memberInfo/updateMain',
    method: 'post',
    data: parameter,
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    }
  })
}

export function infodelete(parameter) {
  return axios({
    timeout: 60000,
    url: '/master/memberInfo/delete',
    method: 'post',
    data: parameter,
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    }
  })
}

export function InfoUpdate(parameter) {
  return axios({
    timeout: 60000,
    url: '/master/memberInfo/update',
    method: 'post',
    data: parameter,
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    }
  })
}

export function Subupdate(parameter) {
  return axios({
    timeout: 60000,
    url: '/master/SubAccount/update',
    method: 'post',
    data: parameter,
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    }
  })
}

export function infoInsert(parameter) {
  return axios({
    url: '/master/info/update',
    method: 'post',
    data: parameter,
    timeout: 60000,
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    }
  })
}

export function foInsert(parameter) {
  return axios({
    timeout: 60000,
    url: '/master/info/insert',
    method: 'post',
    data: parameter,
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    }
  })
}

export function SubAccountadd(parameter) {
  return axios({
    timeout: 60000,
    url: '/master/SubAccount/insert',
    method: 'post',
    data: parameter,
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    }
  })
}
export function disable(parameter) {
  return axios({
    timeout: 60000,
    url: 'master/SubAccount/disable',
    method: 'post',
    data: parameter,
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    }
  })
}


export function SubAccountdelete(parameter) {
  return axios({
    timeout: 60000,
    url: 'master/SubAccount/delete',
    method: 'post',
    data: parameter,
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    }
  })
}
export function SubAccountopen(parameter) {
  return axios({
    timeout: 60000,
    url: 'master/SubAccount/open',
    method: 'post',
    data: parameter,
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    }
  })
}

export function resetPwd(parameter) {
  return axios({
    timeout: 60000,
    url: 'system/user/resetPwd',
    method: 'post',
    data: parameter,
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    }
  })
}


export function insert(parameter) {//添加团队
  return axios({
    timeout: 60000,
    url: '/master/memberInfo/insert',
    method: 'post',
    data: parameter,
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    }
  })
}

export const channelExport = api.channel + '/export'
